(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/views/my-receivers_desktop.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/views/my-receivers_desktop.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.grassroots_shared=_svs.grassroots_shared||{};
_svs.grassroots_shared.templates=_svs.grassroots_shared.templates||{};
svs.grassroots_shared.templates.my_receivers = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "";
},"3":function(container,depth0,helpers,partials,data) {
    return "  <a href=\"\" class=\"js-login\">Logga in</a> för att se och välja dina favoritföreningar\n";
},"5":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"unless").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"hasReceivers") : depth0),{"name":"unless","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":13,"column":2},"end":{"line":15,"column":13}}})) != null ? stack1 : "");
},"6":function(container,depth0,helpers,partials,data) {
    return "        <span class=\"margin-xs-top-1 block\">Inga valda föreningar ännu. Välj förening från topplistorna eller sök.</span>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n\n<div class=\"f-bold f-500 f-content\">Mina föreningar (max 3)</div>\n<div class=\"f-content\">Poängen fördelas jämnt över föreningarna.</div>\n"
    + ((stack1 = (lookupProperty(helpers,"hasRole")||(depth0 && lookupProperty(depth0,"hasRole"))||alias2).call(alias1,{"name":"hasRole","hash":{"role":"Player"},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":5,"column":0},"end":{"line":8,"column":12}}})) != null ? stack1 : "")
    + "<div class=\"my-receivers js-receiver-my-receivers margin-xs-top-1\">\n</div>\n"
    + ((stack1 = (lookupProperty(helpers,"hasRole")||(depth0 && lookupProperty(depth0,"hasRole"))||alias2).call(alias1,{"name":"hasRole","hash":{"role":"Player"},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":0},"end":{"line":16,"column":12}}})) != null ? stack1 : "")
    + "\n";
},"useData":true});
Handlebars.partials['svs-grassroots_shared-my_receivers'] = svs.grassroots_shared.templates.my_receivers;
})(svs, Handlebars);


 })(window);